import React, { lazy } from 'react';
export function ProductDescription() {
  return <section className="max-w-7xl mx-auto px-4 py-8 sm:py-12 md:py-16" data-id="element-360">
      <div className="grid md:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-center mb-8 sm:mb-12" data-id="element-361">
        <div data-id="element-362">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 sm:mb-6" data-id="element-363">
            ¿Por Qué Este Libro Es Diferente?
          </h2>
          <div className="space-y-3 sm:space-y-4 md:space-y-6 text-gray-700 leading-relaxed" data-id="element-364">
            <p className="text-sm sm:text-base md:text-lg" data-id="element-365">
              No es otro libro de recetas que promete "rapidez" y luego te pide
              10 ingredientes que no tienes.
            </p>
            <p className="font-semibold text-base sm:text-lg md:text-xl text-orange-600" data-id="element-366">
              Cada receta en este libro ha sido:
              <br data-id="element-367" />
              ✓ Cronometrada con reloj en mano
              <br data-id="element-368" />
              ✓ Probada por familias reales
              <br data-id="element-369" />✓ Diseñada con ingredientes que YA tienes
            </p>
            <p className="text-sm sm:text-base" data-id="element-370">
              <strong data-id="element-371">15 minutos significa 15 minutos.</strong> No "15 minutos
              más el tiempo de preparación". No "15 minutos si ya tienes todo
              listo". Son 15 minutos reales, desde que prendes la estufa hasta
              que sirves el plato.
            </p>
          </div>
          <div className="mt-4 sm:mt-6 rounded-lg sm:rounded-xl overflow-hidden shadow-xl" data-id="element-372">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hsgq5SCcsYLyhUtouxXDrq/GcNnp3C-RJE46_7aoC5lK.png" alt="Comida deliciosa preparada en minutos" loading="lazy" className="w-full h-48 sm:h-56 md:h-64 object-cover" data-id="element-373" />
          </div>
        </div>
        <div className="rounded-lg sm:rounded-xl overflow-hidden shadow-2xl" data-id="element-374">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xrxLK2HTtkCuD1rRnxvZGS/modelo_4.png" alt="Mujer leyendo 50 Recetas de 15 Minutos" loading="lazy" className="w-full h-full object-cover" data-id="element-375" />
        </div>
      </div>
      <div className="bg-orange-50 p-4 sm:p-6 md:p-8 rounded-lg sm:rounded-xl my-6 sm:my-8" data-id="element-376">
        <h3 className="font-bold text-lg sm:text-xl md:text-2xl mb-4 sm:mb-6" data-id="element-377">
          Lo Que Vas a Encontrar:
        </h3>
        <div className="grid sm:grid-cols-2 gap-3 sm:gap-4 md:gap-6" data-id="element-378">
          <div data-id="element-379">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-380">
              🍝 Pastas Express
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-381">
              10 recetas de pasta que van más allá del típico "con mantequilla"
            </p>
          </div>
          <div data-id="element-382">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-383">
              🍗 Pollo en Minutos
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-384">
              12 formas de cocinar pollo que tu familia va a pedir
            </p>
          </div>
          <div data-id="element-385">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-386">
              🥗 Ensaladas Completas
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-387">
              8 ensaladas que son comidas completas, no guarniciones
            </p>
          </div>
          <div data-id="element-388">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-389">
              🍚 Arroces y Granos
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-390">
              10 recetas con arroz, quinoa y más que se cocinan rápido
            </p>
          </div>
          <div data-id="element-391">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-392">
              🌮 Tacos y Wraps
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-393">
              5 ideas de tacos express que no son aburridos
            </p>
          </div>
          <div data-id="element-394">
            <div className="font-semibold mb-2 text-sm sm:text-base md:text-lg" data-id="element-395">
              🥘 One-Pot Meals
            </div>
            <p className="text-xs sm:text-sm md:text-base text-gray-700" data-id="element-396">
              5 comidas completas en una sola olla
            </p>
          </div>
        </div>
      </div>
      <p className="text-base sm:text-lg md:text-xl text-center italic text-orange-600 py-4 sm:py-6 md:py-8 px-4" data-id="element-397">
        Menos estrés en la cocina. Más tiempo con tu familia. Y comida que todos
        van a disfrutar.
      </p>
    </section>;
}